<big-ui-spinner class="initial-loading-animation">Formular wird geladen...</big-ui-spinner>
